import { makeStyles } from '@eagleview/ev-comp-library';

export default makeStyles((theme) => ({
  comingSoonScreen: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '20px 0px',
    gap: '27px',
    '@media (max-width: 1024px)': {
      padding: '24px 0px 81px 0px',
      gap: '24px',
    },
  },
  pageDescription: {
    fontSize: '36px',
    fontWeight: '300',
    color: theme.evPalette.ocean[700],
    textTransform: 'capitalize',
  },
  redirectionPageImage: {
    display: 'flex',
    justifySelf: 'center',
    maxWidth: '82vw',
    '@media (max-width: 1024px)': {
      height: '234px',
    },
  },
}));
